/**
 * b9ce5b97 (19/10/2026, fala do dono ac38b56d) — com o servidor carregado, uma leitura que falhava uma vez punha na tela
 * "Não foi possível conferir a entrega" e "Não foi possível atualizar a conversa", e o dono via o aviso ir e voltar.
 * Falha passageira tenta de novo em silêncio; o aviso só aparece quando as falhas seguidas passam de 1 min.
 */
export const OWNER_TRANSIENT_FAILURE_MS = 60_000;

export interface TransientFailureGate {
  /** Leitura bem-sucedida: zera a contagem. */
  ok(): void;
  /** Leitura falhou: `true` quando as falhas seguidas já duram o bastante para avisar o dono. */
  failed(): boolean;
}

export function transientFailureGate(now: () => number = () => Date.now(), thresholdMs = OWNER_TRANSIENT_FAILURE_MS): TransientFailureGate {
  let since: number | null = null;
  return {
    ok() { since = null; },
    failed() { since ??= now(); return now() - since >= thresholdMs; },
  };
}
